import { useDidMount, useUpdateEffect } from 'utils/hooks';

export const useFolderLifecyle = ({ reduxState, handlers }) => {
  useDidMount(handlers.handleFetchDocumentSavedFoldersCount);

  useUpdateEffect(handlers.handleFetchDocumentSavedFoldersCount, [reduxState.rightPanelDocument]);
};
